<template>
  <a-form :form="pageForm" class="page-content">
    <div class="form-content">
      <a-form-item
        v-if="pItemData.id"
        label="父级大区"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          disabled
          v-decorator="[
            'parent',
            {
              initialValue: '【' + pItemData.id + '】' + pItemData.name
            }
          ]"
        />
      </a-form-item>
      <a-form-item
        v-if="pItemData.id"
        :style="{
          margin: '0px auto 10px',
          width: '80%',
          height: '0px',
          'border-bottom': '1px solid #dcdcdc'
        }"
      ></a-form-item>

      <a-form-item
        label="大区名称"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'name',
            {
              initialValue: formData.name,
              rules: [{ required: true, message: '请输入大区名称' }]
            }
          ]"
        />
        <br />
        <span class="ant-form-item-tips">配置大区名称</span>
      </a-form-item>

      <a-form-item
        label="大区说明"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-textarea
          v-decorator="[
            'summary',
            {
              initialValue: formData.summary
            }
          ]"
          placeholder="请输入大区说明..."
          :rows="4"
        />
      </a-form-item>

      <a-form-item
        label="菜单排序"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input
          v-decorator="[
            'sort',
            {
              initialValue: formData.sort,
              rules: [{ required: true, message: '请输入排序' }]
            }
          ]"
        />
      </a-form-item>
    </div>
    <div class="divider-land"></div>
    <a-form-item style="text-align:center;">
      <a-button
        style="margin-right:20px; width:100px;"
        @click.stop="cancelForm"
      >
        取 消
      </a-button>
      <a-button type="primary" style="width:100px;" @click.stop="submitForm">
        {{ submitBtnLabel }}
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
var pageContext;
export default {
  props: {
    submitBtnLabel: {
      type: String,
      default: () => {
        return "新 增";
      }
    },
    platform_type: {
      type: String,
      default: () => {
        return "cp";
      }
    },
    company_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    pItemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  beforeCreate() {
    pageContext = this;
    pageContext.pageForm = pageContext.$form.createForm(pageContext, {
      onValuesChange: function(props, values) {
        let key = Object.keys(values)[0];
        pageContext.formData[key] = values[key];
      }
    });
  },
  data() {
    return {
      formData: pageContext.initFormData()
    };
  },
  mounted() {
    console.log(pageContext.platform_type);
  },
  methods: {
    initFormData() {
      //编辑大区
      if (pageContext.itemData.id) {
        return {
          id: pageContext.itemData.id,
          name: pageContext.itemData.name,
          summary: pageContext.itemData.summary,
          sort: pageContext.itemData.sort
        };
      }
      //新增下级大区
      else if (pageContext.pItemData.id) {
        return {
          pid: pageContext.pItemData.id,
          path: pageContext.pItemData.path + pageContext.pItemData.id + ",",
          platform_type: pageContext.pItemData.platform_type,
          company_id: pageContext.pItemData.company_id,
          name: "",
          summary: "",
          sort: 100
        };
      }
      //新增顶级大区
      else {
        return {
          pid: "0",
          path: "0,",
          platform_type: pageContext.platform_type,
          company_id: pageContext.company_id,
          name: "",
          summary: "",
          sort: 100
        };
      }
    },
    async submitForm() {
      let result = false;
      pageContext.pageForm.validateFields((errors, values) => {
        result = errors !== null;
      });
      if (result) {
        pageContext.$message.error("请检查表单");
        return;
      }

      pageContext.$http
        .post("/area/update", pageContext.formData)
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查1");
          console.log(error);
        });
    },
    cancelForm() {
      pageContext.$layer.close(pageContext.layerid);
      pageContext.$message.info("操作取消！");
    }
  }
};
</script>
<style scoped lang="scss">
.page-content {
  width: 100%;

  .form-content {
    width: 95%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .divider-land {
    background-color: #dcdcdc;
    height: 1px;
    width: 80%;
    margin: 10px auto;
  }
}
</style>
